import { getNativeBridge } from './native-bridge';

const senses2Ready = () => {
  document.dispatchEvent(new Event('senses2Ready'));
};

interface NativeBridgeReady {
  ready?: boolean;
}

const nativeBridgeReady = () => {
  return getNativeBridge<NativeBridgeReady>()?.ready === true;
};

export const nativeBridgeHandshake = (): Promise<void> => {
  return new Promise((resolve) => {
    if (nativeBridgeReady()) {
      senses2Ready();
      resolve();
    } else {
      document.addEventListener(
        'nativeBridgeReady',
        () => {
          senses2Ready();
          resolve();
        },
        { once: true },
      );
    }
  });
};
